export var focusFirstInput = function (root, selector) {
    var observer = new MutationObserver(function () {
        // Some APIs may returns identifiers with slashes (API Platform for instance). We need to escape them to have valid CSS selectors
        var sanitizedSelector = selector.replace(/\//g, '\\/');
        // once the row is replaced by a form, focus the first non-disabled input
        // [role="combobox"] targets MUI Select
        var input = root.querySelectorAll("".concat(sanitizedSelector, " input:not([disabled]):not([readonly]), ").concat(sanitizedSelector, " [role=\"combobox\"]:not([disabled]):not([readonly]), ").concat(sanitizedSelector, " textarea:not([disabled]):not([readonly])"))[0];
        if (input) {
            observer.disconnect();
            if (input) {
                // If the input supports selection (text inputs for instance), we select the text to make it easier to replace
                if (input.select) {
                    input.select();
                }
                else if (input.focus) {
                    input.focus();
                }
            }
        }
    });
    observer.observe(root, {
        subtree: true,
        childList: true,
    });
    return observer;
};
